<template>
    <base-form-control v-bind="formControlAttributes">
        <slot name="prepend"></slot>
        <v-select class="control" :class="actionBtnClasses" v-bind="controlAttributes" :clearable="clearable" v-model="model" :disabled="disabled" :multiple="multiple" v-on="listeners" :options="options"></v-select>
        <slot name="append"></slot>
    </base-form-control>
</template>

<script>
import BaseInput from './BaseInput';
import VueSelectCommons from './VueSelectCommons';

export default {
    name    : 'form-select',
    extends : BaseInput,
    mixins  : [VueSelectCommons],
    data () {
        return { model : '' };
    },
    props : {
        options : {
            type : Array,
            default () {
                return [];
            }
        }
    },
    mounted () {
        this.findModel();
    },
    methods : {}

};
</script>
